<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="formData.name"
          label="Nome"
          outlined
          hide-details="auto"
          dense
          required
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="formData.domain"
          label="Domínio"
          outlined
          hide-details="auto"
          dense
          required
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="formData.email"
          label="Email"
          outlined
          hide-details="auto"
          dense
          required
          :rules="[rules.required, rules.email]"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="formData.phone"
          label="Telefone"
          outlined
          hide-details="auto"
          dense
          required
          @input="formatPhone"
          :rules="[rules.required, rules.phone]"
        />
      </v-col>
      <v-col cols="12">
        <v-alert
          text
          :color="formData.hidePoweredBy ? 'primary' : 'success'"
          class="mb-0"
          dense
        >
          <div class="d-flex align-center justify-space-between">
            <div>
              <b class="d-block"> Ocultar "Powered By" </b>
              <span>
                Powered By será
                {{ formData.hidePoweredBy ? "oculto" : "exibido" }}
              </span>
            </div>
            <v-switch
              v-model="formData.hidePoweredBy"
              dense
              hide-details
              class="ma-0"
              disabled
            />
          </div>
        </v-alert>
      </v-col>
    </v-row>

    <slot name="actions"></slot>
  </div>
</template>

<script>
export default {
  name: "BasicInfoStep",
  props: {
    value: {
      type: Object,
      required: true,
    },
    oldValue: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    rules: {
      required: (v) => !!v || "Campo obrigatório",
      email: (v) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(v) || "E-mail inválido";
      },
      phone: (v) => {
        const pattern = /^\(\d{2}\) \d{5}-\d{4}$/;
        return pattern.test(v) || "Telefone inválido";
      },
    },
  }),
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    hasChanges() {
      if (this.oldValue.name !== this.formData.name.trim()) return true;
      if (this.oldValue.domain !== this.formData.domain.trim()) return true;
      if (this.oldValue.email !== this.formData.email.trim()) return true;
      if (this.oldValue.phone !== this.formData.phone.trim()) return true;
      if (this.oldValue.hidePoweredBy !== this.formData.hidePoweredBy)
        return true;
      return false;
    },
  },
  methods: {
    getFormData() {
      if (!this.hasChanges) return false;
      return {
        name: this.formData.name,
        domain: this.formData.domain,
        email: this.formData.email,
        phone: this.formData.phone,
        hidePoweredBy: this.formData.hidePoweredBy,
      };
    },
    formatPhone(value) {
      if (!value) return "";
      value = value.replace(/\D/g, "");
      if (value.length > 11) value = value.slice(0, 11);

      if (value.length > 6) {
        this.formData.phone = `(${value.slice(0, 2)}) ${value.slice(
          2,
          7
        )}-${value.slice(7)}`;
      } else if (value.length > 2) {
        this.formData.phone = `(${value.slice(0, 2)}) ${value.slice(2)}`;
      } else if (value.length > 0) {
        this.formData.phone = `(${value}`;
      } else {
        this.formData.phone = value;
      }
    },
  },
};
</script>
